import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import UserSettingsModal from './UserSettingsModal';
import AddAITicketModal from './AddAITicketModal';
import AnimatedLogo from './AnimatedLogo';
import styles from './Navbar.module.css';

const Navbar = ({ onAddBucket, showDoneTickets, onToggleDoneTickets, onShowToday, isTimerActive }) => {
  const { currentUser, logout } = useContext(AuthContext);
  const [isMobile, setIsMobile] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showUserSettings, setShowUserSettings] = useState(false);
  const [showAddAITicket, setShowAddAITicket] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  return (
    <nav className={`${styles.navbar} ${isTimerActive ? styles.timerActive : ''}`}>
      <div className={styles.navbarBrand}>
        <AnimatedLogo animated={false} width={90} />
        <span className={styles.brandText}>WS Tickets</span>
      </div>
      
      {currentUser && (
        <>
          <div className={styles.navbarActions}>
            <button onClick={() => setShowAddAITicket(true)} className={styles.actionButton}>
              Smart Ticket
            </button>
            <button onClick={onAddBucket} className={styles.actionButton}>
              Add Bucket
            </button>
            <button onClick={onShowToday} className={styles.actionButton}>
              Heute
            </button>
            <button onClick={() => setShowUserSettings(true)} className={styles.actionButton}>
              Einstellungen
            </button>
            <div className={styles.switchContainer}>
              <span className={styles.switchLabel}>Show Done</span>
              <div 
                className={`${styles.switch} ${showDoneTickets ? styles.switchOn : styles.switchOff}`}
                onClick={onToggleDoneTickets}
              >
                <div className={styles.switchHandle}></div>
              </div>
            </div>
          </div>

          {isMobile && (
            <div className={styles.mobileDropdown}>
              <button 
                className={styles.dropdownButton}
                onClick={() => setShowDropdown(!showDropdown)}
              >
                ⋮
              </button>
              {showDropdown && (
                <div className={styles.dropdownMenu}>
                  <button onClick={() => {
                    setShowAddAITicket(true);
                    setShowDropdown(false);
                  }} className={styles.dropdownItem}>
                    Smart Ticket
                  </button>
                  <button onClick={() => {
                    onAddBucket();
                    setShowDropdown(false);
                  }} className={styles.dropdownItem}>
                    Add Bucket
                  </button>
                  <button onClick={() => {
                    onShowToday();
                    setShowDropdown(false);
                  }} className={styles.dropdownItem}>
                    Heute
                  </button>
                  <button onClick={() => {
                    setShowUserSettings(true);
                    setShowDropdown(false);
                  }} className={styles.dropdownItem}>
                    Einstellungen
                  </button>
                  <div className={styles.dropdownItem}>
                    <span>Show Done</span>
                    <div 
                      className={`${styles.switch} ${showDoneTickets ? styles.switchOn : styles.switchOff}`}
                      onClick={() => {
                        onToggleDoneTickets();
                        setShowDropdown(false);
                      }}
                    >
                      <div className={styles.switchHandle}></div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          
          <div className={styles.navbarUser}>
            <span className={styles.username}>
              {currentUser.username} 
              {currentUser.role === 'admin' && <span className={styles.adminBadge}>Admin</span>}
            </span>
            <button onClick={logout} className={styles.logoutButton}>
              Logout
            </button>
          </div>
        </>
      )}

      <UserSettingsModal
        isOpen={showUserSettings}
        onClose={() => setShowUserSettings(false)}
      />

      <AddAITicketModal
        isOpen={showAddAITicket}
        onClose={() => setShowAddAITicket(false)}
      />
    </nav>
  );
};

export default Navbar;
